const useGenerealInitialStates = () => {
  const generalInitialState = { pp_pdf: "http://www.africau.edu/images/default/sample.pdf" };
  return { generalInitialState };
};

export default useGenerealInitialStates;
